import { formatNumberForDisplay } from '@/common';
import { IBrokerOfficePriceRange } from '@/types';

export const formatOfficePriceRange = (
  range?: IBrokerOfficePriceRange | null,
): string | undefined => {
  if (range?.from == null || range?.to == null) return undefined;

  const currency = !range.currency || range.currency === 'EUR' ? '€' : range.currency;
  return `${formatNumberForDisplay(range.from)} ${currency} – ${formatNumberForDisplay(range.to)} ${currency}`;
};
